// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__qvyb5","header":"Dashboard_header__NsD-g","grid":"Dashboard_grid__n5Wox","column":"Dashboard_column__ZxCcz"};